import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phoneNumber = control.value;

    if (!phoneNumber) {
      return null;
    }

    const phoneNumberPattern = /^\+[1-9]\d{6,14}$/;
    return phoneNumberPattern.test(phoneNumber) ? null : { phoneNumber: true };
  };
}
